import { chartsStrings } from "~/translations/dashboard/charts";
import type { Language } from "~/utils/language";

type CashflowDateRangeLabelProps = {
  month: string;
  lang: Language;
  className?: string;
};

const DIRECTIONAL_MARKS_REGEX = /[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g;

export default function CashflowDateRangeLabel({
  month,
  lang,
  className = "",
}: CashflowDateRangeLabelProps) {
  const cleanMonth = month.replace(DIRECTIONAL_MARKS_REGEX, "").trim();
  const separator = chartsStrings[lang].until;
  const parts = cleanMonth.split(new RegExp(`\\s+${separator}\\s+`));

  if (parts.length !== 2) {
    return (
      <div dir="ltr" className={className}>
        {cleanMonth}
      </div>
    );
  }

  return (
    <div
      dir="ltr"
      className={`inline-flex items-center justify-center gap-1 ${className}`}
    >
      <span dir="ltr">{parts[0]}</span>
      <span dir={lang === "HEB" ? "rtl" : "ltr"}>{separator}</span>
      <span dir="ltr">{parts[1]}</span>
    </div>
  );
}
